export default {
  root: {
    borderRadius: '20px',
  },
  colorScheme: {
    light: {
      root: {
        invalidBorderColor: '{form.field.invalid.border.color}',
      },
    },
    dark: {
      root: {
        invalidBorderColor: '{form.field.invalid.border.color}',
      },
    },
  },
};
